import React from 'react'
import { cx, css } from 'linaria'
import { ReactComponent as NoticeSVG } from '../../svg/notice.svg'

export function GlobalError({ children, className }) {
   return (
      <div className={cx(error, className)}>
         <div>{children}</div>
         <aside>
            <NoticeSVG />
         </aside>
      </div>
   )
}

const error = css`
   color: #e2a300;
   margin-top: 0.5rem;
   padding: 0.5em 1em;
   background: #f7f5f2;
   font-size: 0.875rem;
   display: flex;
   line-height: 1.5;

   p {
      margin: 0;
   }

   aside {
      margin-left: auto;
   }

   aside > svg {
      height: 20px;
      width: 20px;
   }
`
